import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Grid, Box, CircularProgress } from "@mui/material";
import { connect } from "react-redux";
import SellerDashboardNav from "../../components/seller/navbar/NavList";
import SellerDashboardDrawer from "../../components/seller/navbar/SellerDrawer";
import * as Actions from "../../redux/actions";

function SellerLayout({ getUserBillingPortal, user, seller, refreshSeller }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      navigate("/auth/login");
      return;
    }
    getUserBillingPortal(user.id);
    refreshSeller().finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Box sx={{ minHeight: "100vh", backgroundColor: "#111", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <CircularProgress sx={{ color: "#FFC001" }} />
      </Box>
    );
  }

  if (!seller || seller.approval_status !== "approved") {
    navigate("/seller/register");
    return null;
  }

  return (
    <>
      <SellerDashboardDrawer />
      <Grid
        container
        md={12}
        sx={{
          backgroundColor: "#111",
          width: "100vw",
          overflowX: "hidden",
        }}
      >
        <Grid
          item
          md={2}
          sx={{
            display: {
              xs: "none",
              sm: "none",
              md: "flex",
              position: "sticky",
              zIndex: 5,
            },
          }}
        >
          <SellerDashboardNav />
        </Grid>
        <Grid item xs={12} md={10}>
          <Outlet />
        </Grid>
      </Grid>
    </>
  );
}

const mapStateToProps = ({ Auth, Seller }) => ({
  responseErrors: Auth.responseError,
  user: Auth.user,
  seller: Seller.seller,
});

const mapDispatchToProps = (dispatch) => ({
  getUserBillingPortal: (userId) =>
    dispatch(Actions.thunkGetUserBillingPortal(userId)),
  refreshSeller: () => dispatch(Actions.thunkGetSeller()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SellerLayout);
